// Mock data for WNE Linkhub
// NOTE: This file is only used by PrintPage.jsx for static print layout
// All other pages use dynamic data from the API

export const linksConfig = {
  film_url: "https://player.vimeo.com/video/1069761042?h=bd5d65b916&title=0&autopause=0&app_id=122963",
  cee_llc_url: "https://www.congressionalenergyengagement.com",
  ceef_url: "https://www.usceef.org",
  report_url: "https://innovationreform.org/wp-content/uploads/2025/08/2025-08-05-Nuclear-energy.pdf",
  utm: "utm_source=wne&utm_medium=qr&utm_campaign=paris2025"
};

export const contacts = [
  { name: "Michelle Amante-Harstine", email: "michelle@usceef.org" },
  { name: "General Inquiries", email: "Contact@usceef.org" },
  { name: "Sam Thernstrom", email: "sam@innovationreform.org" },
  { name: "Paul Saunders", email: "paul@innovationreform.org" }
];

export const branding = {
  tagline: "Advancing Energy. Strengthening America. Leading the World.",
  title: "Congressional Energy Engagement Group",
  vanityUrl: "https://usceef.org/wne"
};

// Mock analytics - will be replaced with actual API calls
export const trackEvent = (eventName, data) => {
  console.log('[Analytics Mock]', eventName, data);
  // Store in localStorage for demo purposes
  const events = JSON.parse(localStorage.getItem('wne_analytics') || '[]');
  events.push({
    event: eventName,
    data,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('wne_analytics', JSON.stringify(events));
};

